import React from 'react'
import Navbar from '../components/Navbar'

const Subscriptions = () => {
  return (
    <div>
      <Navbar/>
    </div>
  )
}

export default Subscriptions
